import classNames from 'classnames';

// styles
import s from './Checkbox.sss';

type CheckboxProps = {
  className?: string,
  inputClassName?: string,
  checked: boolean;
  onCheck?: () => void
};

export const Checkbox: React.FC<React.PropsWithChildren<CheckboxProps>> = ({
  checked,
  onCheck,
  children,
  className,
  inputClassName,
  ...props
}) => (
  (
    <label className={classNames(s.root, className)}>
      <div className={classNames(s.checkboxOuter, inputClassName, { [s.checked]: checked })}>
        <input
          type="checkbox"
          className={s.checkbox}
          checked={checked}
          onChange={onCheck}
          {...props}
        />
      </div>
      {children}
    </label>
  )
);

export default Checkbox;
